import type { GetV2OsInstallersVersionDownloadQueryParams } from '@emma/api_client/types';
import { Download } from '@lego/klik-ui/icons';
import { useInstallerDownload } from '@/hooks/os';
import { createColumnHelper } from '../appTable';

export type InstallerRow = {
  version: string;
  architecture: GetV2OsInstallersVersionDownloadQueryParams['architecture'];
  variant: NonNullable<GetV2OsInstallersVersionDownloadQueryParams['variant']>;
  rhel: string;
};

const DownloadIcon = ({ row }: { row: InstallerRow }) => {
  const download = useInstallerDownload();

  const handleClick = () => {
    void download(row.version, row.architecture, row.variant);
  };

  return (
    <Download color="#3182ce" cursor="pointer" height="20px" onClick={handleClick} width="20px" />
  );
};

const columnHelper = createColumnHelper<InstallerRow>();

export const osInstallerTableColumns = columnHelper.columns([
  columnHelper.accessor('version', {
    header: 'Version',
    meta: { filterVariant: { type: 'singleSearch' } },
  }),
  columnHelper.accessor('architecture', {
    header: 'Architecture',
    meta: {
      filterVariant: {
        type: 'singleSelect',
        options: [
          { name: 'amd64', filterValue: 'amd64' },
          { name: 'arm64', filterValue: 'arm64' },
        ],
      },
    },
  }),
  columnHelper.accessor('variant', {
    header: 'Variant',
    meta: {
      filterVariant: {
        type: 'singleSelect',
        options: [
          { name: 'base', filterValue: 'base' },
          { name: 'kiosk', filterValue: 'kiosk' },
          { name: 'nvidia-open580', filterValue: 'nvidia-open580' },
          { name: 'nvidia-open595', filterValue: 'nvidia-open595' },
        ],
      },
    },
  }),
  columnHelper.accessor('rhel', {
    header: 'RHEL',
    meta: { filterVariant: { type: 'singleSearch' } },
  }),
  columnHelper.display({
    id: 'download',
    header: 'Download',
    cell: ({ row }) => <DownloadIcon row={row.original} />,
    enableSorting: false,
  }),
]);
